/*
 * lc-cart-throttle-guard.js — La Carnicerie
 * Mitiga el checkpoint "Verifying your connection" (HTTP 429) de Shopify que
 * aparece al agregar productos al carrito muy rápido. Encola las peticiones del
 * carrito (una a la vez) y reintenta si Shopify responde con el bloqueo.
 * Diseño "fail-open": ante cualquier problema usa el fetch nativo sin tocar nada.
 *
 * Activación: por defecto SOLO con ?lc_cart_guard=1 (modo prueba; se recuerda en
 * la sesión). Para activarlo en toda la tienda, cambiar DEFAULT_ON a true.
 */
(function () {
  'use strict';
  var DEFAULT_ON = true; // <-- cambiar a true para activar en toda la tienda

  try {
    var ACTIVE = DEFAULT_ON || window.LC_CART_GUARD === true;
    try {
      if ((window.location.search || '').indexOf('lc_cart_guard=1') !== -1) {
        sessionStorage.setItem('lc_cart_guard', '1');
      }
      if (sessionStorage.getItem('lc_cart_guard') === '1') ACTIVE = true;
    } catch (_) {}
    if (!ACTIVE || window.__lcCartGuardOn || typeof window.fetch !== 'function') return;
    window.__lcCartGuardOn = true;

    var nativeFetch = window.fetch.bind(window);
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?($|\?|#)/i;
    var SPACING_MS = 150, MAX_RETRIES = 3, BASE_BACKOFF = 700, CHAIN_CAP_MS = 6000;
    var chain = Promise.resolve();

    function delay(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    function throttled(res) {
      if (!res) return false;
      if (res.status === 429 || res.status === 430) return true;
      try {
        var ct = (res.headers.get('content-type') || '').toLowerCase();
        return ct.indexOf('json') === -1 && ct.indexOf('html') !== -1;
      } catch (_) { return false; }
    }

    function attempt(args, n) {
      return nativeFetch.apply(null, args).then(function (res) {
        if (throttled(res) && n < MAX_RETRIES) {
          return delay(BASE_BACKOFF * n).then(function () { return attempt(args, n + 1); });
        }
        return res;
      });
    }

    window.fetch = function () {
      var args = arguments, url = '';
      try {
        url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
      } catch (_) {}
      if (!url || !CART_RE.test(url)) return nativeFetch.apply(this, args);

      var run = chain.then(function () { return attempt(args, 1); });
      // El siguiente en la cola arranca cuando este termina (+espacio). El tope
      // de seguridad evita que la cola se trabe si una petición se cuelga.
      chain = Promise.race([
        run.then(function () { return delay(SPACING_MS); }, function () { return delay(SPACING_MS); }),
        delay(CHAIN_CAP_MS)
      ]);
      return run;
    };
  } catch (e) { /* fail-open: no se toca window.fetch */ }
})();
